import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Alert, Card, Spinner } from "../../../components/ui";
import { AppShell } from "../../../layouts/AppShell";
import { getQuestionnaireSubmission } from "../api/questionnaireResultsApi";

export function QuestionnaireSubmissionDetailPage() {
  const { submissionId = "" } = useParams();
  const query = useQuery({
    queryKey: ["questionnaire", "submission", submissionId],
    queryFn: () => getQuestionnaireSubmission(submissionId),
    enabled: Boolean(submissionId),
  });

  return (
    <AppShell
      title="具名填答明細"
      breadcrumb={["管理後台", "固定問卷", "結果", "明細"]}
    >
      {query.isLoading && <Spinner label="載入填答" />}
      {query.isError && (
        <Alert variant="danger">找不到填答或您沒有權限。</Alert>
      )}
      {query.data && (
        <>
          <Card title={query.data.member.registrantName}>
            <p>{query.data.member.companyName}</p>
            <p>問卷版本：V{query.data.versionNumber}／{query.data.versionTitle}</p>
            <p>送出時間：{new Date(query.data.submittedAt).toLocaleString()}</p>
          </Card>
          {query.data.answers.map((answer) => (
            <Card
              key={answer.questionKey}
              title={`${answer.questionCode} — ${answer.prompt}`}
            >
              <p className="mb-0">
                {answer.textValue ?? answer.selectedLabel ?? answer.ratingValue}
                {answer.otherText ? `（${answer.otherText}）` : ""}
              </p>
            </Card>
          ))}
        </>
      )}
    </AppShell>
  );
}
